// Anita Week 5 / Day 3 — Факт, мнение и доказательство / Fact, Opinion, Evidence.

const day3 = {
  id: 'day-3',
  studentId: 'anita',
  weekId: 'week-5',
  dayId: 'day-3',
  status: 'active',
  title: 'Факт, мнение и доказательство / Fact, Opinion and Evidence',
  shortTitle: 'Факт и мнение / Fact and Opinion',
  theme: 'Анита учится отличать факт от мнения и просить доказательство. / Anita separates fact from opinion and asks for evidence.',
  estimatedTimeLabel: '60–90 минут / 60–90 minutes',
  lessonTiming: { minMinutes: 60, maxMinutes: 90, breaks: 2 },
  bilingualMode: 'ru-primary-en-helper',
  courseLayers: ['reading', 'math', 'information-literacy', 'logic', 'spelling', 'creative', 'speech'],
  readingLevel: 'grade-2',
  nimnyIntro: 'Нимни: факт можно проверить, мнение — это то, что человек думает. / Nimny: fact can be checked, opinion is what a person thinks.',
  goals: ['Считать факты, мнения и остаток из 36 предложений.', 'Работать с группами доказательств.', 'Найти слабое утверждение.', 'Считать нимы (72 − 18 − 24).', 'Делить 42 на 6.'],
  vocabulary: [
    { term: 'факт / fact', definition: 'то, что можно проверить. / provable.' },
    { term: 'мнение / opinion', definition: 'то, что человек думает. / a personal view.' },
    { term: 'доказать / to prove', definition: 'показать, что это правда. / show it is true.' },
    { term: 'видеть / to see', definition: 'смотреть глазами. / with eyes.' },
    { term: 'думать / to think', definition: 'работа мысли. / mind work.' }
  ],
  onlineTasks: [
    { id: 'reading-words', type: 'text', title: 'Задание 1 — Слова темы / Theme Words',
      prompt: 'Прочитай:\nфакт\nмнение\nдоказать\nвидеть\nдумать',
      ruPrimaryText: 'Прочитай 5 слов темы.', enHelpText: 'Read 5 words.', answer: 'Попытка чтения.' },
    { id: 'reading-sentences', type: 'text', title: 'Задание 2 — Маленькое чтение / Short Reading',
      prompt: 'Прочитай:\nФакт можно проверить и доказать.\nМнение показывает, что человек думает.\nСильное утверждение подкреплено доказательством.\nСлабое утверждение — только «мне нравится».',
      ruPrimaryText: 'Прочитай 4 фразы.',
      enHelpText: 'Fact can be proven. Opinion is a personal view.',
      answer: 'Попытка чтения.' },
    { id: 'math-36-sentences', type: 'text', title: 'Задание 3 — 36 предложений / 36 Sentences',
      prompt: 'В тексте 36 предложений. 1/3 — факты, 1/4 — мнения, остальные нужно проверить.\n\nОтветь:\n1. Сколько фактов?\n2. Сколько мнений?\n3. Сколько нужно проверить?',
      ruPrimaryText: '1/3 и 1/4 от 36 + остаток.',
      enHelpText: 'Find 1/3 and 1/4 of 36; subtract from 36.',
      answer: '1) 36 ÷ 3 = 12. 2) 36 ÷ 4 = 9. 3) 36 − 12 − 9 = 15.' },
    { id: 'math-evidence-groups', type: 'text', title: 'Задание 4 — Группы доказательств / Evidence Groups',
      prompt: 'Анита нашла 5 групп доказательств по 4 карточки. Потом 6 карточек оказались лишними.\n\nОтветь:\n1. Сколько карточек всего?\n2. Сколько карточек осталось?',
      ruPrimaryText: 'Умножение × вычитание.',
      enHelpText: 'Multiply 5 × 4; subtract 6.',
      answer: '1) 5 × 4 = 20. 2) 20 − 6 = 14.' },
    { id: 'math-nims-72', type: 'text', title: 'Задание 5 — Нимы Аниты / Anita\'s Nims',
      prompt: 'У Аниты 72 нима. Она потратила 18 нимов на книгу и 24 нима на материалы проекта.\n\nОтветь:\n1. Сколько потратила?\n2. Сколько осталось?',
      ruPrimaryText: 'Сумма трат + остаток.',
      enHelpText: 'Add spending; subtract from 72.',
      answer: '1) 18 + 24 = 42. 2) 72 − 42 = 30 нимов.' },
    { id: 'math-42-days', type: 'text', title: 'Задание 6 — Дни проверки / Check Days',
      prompt: 'Анита проверяет по 6 утверждений в день.\n\nОтветь:\n1. Сколько дней нужно, чтобы проверить 42 утверждения?',
      ruPrimaryText: 'Простое деление.',
      enHelpText: 'Divide 42 by 6.',
      answer: '1) 42 ÷ 6 = 7 дней.' },
    { id: 'logic-weak-claim', type: 'text', title: 'Задание 7 — Слабое утверждение / Weak Claim',
      prompt: 'Найди слабое утверждение:\nA: «На улице идёт дождь, я вижу мокрую дорогу.»\nB: «Эта книга самая лучшая, потому что мне нравится.»\nC: «Вода мокрая.»\nD: «Сегодня вторник по календарю.»\n\nОтветь 1–3 предложения: какое слабое и почему?',
      ruPrimaryText: 'Логика: факт vs мнение.',
      enHelpText: 'A weak claim is opinion without proof.',
      answer: 'B, потому что это мнение, а не доказанный факт.' },
    { id: 'spelling-day3', type: 'text', title: 'Задание 8 — Правописание / Spelling',
      prompt: 'Напиши:\nфакт\nмнение\nдоказать\nвидеть\nдумать\n\nВставь буквы:\nф_кт\nмн_ние\nдок_зать\nв_деть\nд_мать',
      ruPrimaryText: 'Напиши 5 слов и вставь буквы.',
      enHelpText: 'Write 5 words and fill in letters.',
      answer: 'факт, мнение, доказать, видеть, думать.' },
    { id: 'creative-fact-opinion', type: 'text', title: 'Задание 9 — Мои факт и мнение / My Fact & Opinion',
      prompt: 'Нарисуй карточку-проект и напиши:\n1. Мой факт: «______» (можно проверить).\n2. Моё мнение: «______» (мне нравится, но не факт).',
      ruPrimaryText: 'Нарисуй карточку + 1 факт и 1 мнение.',
      enHelpText: 'Write one fact and one opinion.',
      answer: 'Open-ended. 1 факт + 1 мнение.' },
    { id: 'speech-day3', type: 'text', title: 'Задание 10 — Объясни родителю / Explain to Parent',
      prompt: 'Скажи родителю:\nФакт — то, что можно проверить.\nМнение — то, что человек думает.\nЯ прошу доказательство.',
      ruPrimaryText: 'Объясни факт и мнение по-русски.',
      enHelpText: 'Fact vs opinion; ask for proof.',
      answer: 'Accept if expressed in Russian.' }
  ],
  notebookInstructions: [
    'Если нет принтера:',
    '1. Начерти таблицу фактов и мнений.',
    '2. Реши задачи 3–6.',
    '3. Напиши свою карточку факта и мнения.',
    '4. Расскажи родителю.'
  ],
  printWorksheet: {
    title: 'Факт, мнение и доказательство / Fact, Opinion, Evidence',
    subtitle: 'Неделя 5 · День 3 / Week 5 · Day 3',
    pages: [
      { title: 'Маршрут и математика / Route and Math', blocks: [
        { type: 'text', text: 'Имя: __________________________   Дата: __________________________' },
        { type: 'text', text: 'Миссия: сегодня ты учишься отличать факт от мнения.' },
        { type: 'text', text: 'Задание 1 — Слова темы:' },
        { type: 'list', items: ['факт / fact', 'мнение / opinion', 'доказать / to prove', 'видеть / to see', 'думать / to think'] },
        { type: 'text', text: 'Задание 2 — Маленькое чтение:' },
        { type: 'list', items: ['□ Факт можно проверить и доказать.', '□ Мнение показывает, что человек думает.', '□ Сильное утверждение — с доказательством.', '□ Слабое утверждение — только «мне нравится».'] },
        { type: 'text', text: 'Задание 3 — 36 предложений. Готовая таблица:' },
        { type: 'list', items: [
          'Всего            | 36',
          'Факты (1/3)      | 36 ÷ 3 = ___',
          'Мнения (1/4)     | 36 ÷ 4 = ___',
          'Проверить        | 36 − ___ − ___ = ___'
        ] },
        { type: 'text', text: 'Задание 4 — Группы доказательств:' },
        { type: 'list', items: ['5 × 4 = ___ карточек всего', '___ − 6 = ___ карточек осталось'] }
      ] },
      { title: 'Нимы, время и логика / Nims, Time, Logic', blocks: [
        { type: 'text', text: 'Задание 5 — Нимы (72 всего):' },
        { type: 'list', items: ['Потратила = 18 + 24 = ___', 'Осталось = 72 − ___ = ___ нимов'] },
        { type: 'text', text: 'Задание 6 — Дни проверки:' },
        { type: 'list', items: ['42 ÷ 6 = ___ дней'] },
        { type: 'text', text: 'Задание 7 — Слабое утверждение. Отметь:' },
        { type: 'list', items: ['□ A: «На улице идёт дождь, я вижу мокрую дорогу.»', '□ B: «Эта книга самая лучшая, потому что мне нравится.»', '□ C: «Вода мокрая.»', '□ D: «Сегодня вторник по календарю.»'] },
        { type: 'text', text: 'Почему: _________________________________________________________________________________________' }
      ] },
      { title: 'Русский, проект и защита / Russian, Project, Defense', blocks: [
        { type: 'text', text: 'Задание 8 — Правописание:' },
        { type: 'list', items: ['факт   мнение   доказать   видеть   думать', 'ф_кт    мн_ние    док_зать    в_деть    д_мать'] },
        { type: 'text', text: 'Задание 9 — Мои факт и мнение. Нарисуй карточку-проект:' },
        { type: 'list', items: ['Мой факт: __________________________________________', 'Моё мнение: ________________________________________'] },
        { type: 'text', text: 'Задание 10 — Объясни родителю:' },
        { type: 'list', items: ['□ Факт — можно проверить.', '□ Мнение — что человек думает.', '□ Я прошу доказательство.'] },
        { type: 'text', text: 'Parent Check: □ слова  □ фразы  □ 1/3 и 1/4 от 36  □ 5 × 4 − 6  □ нимы 72  □ 42 ÷ 6  □ слабое утверждение B  □ факт+мнение  □ защита.' },
        { type: 'text', text: 'Notebook Mode fallback: если нет принтера, начерти таблицу и карточку факта/мнения в тетради.' }
      ] }
    ]
  },
  parentGuide: {
    practicalGoal: 'Уметь отделить факт от мнения.',
    whatThisLessonTeaches: 'Разница факта и мнения; работа с дробями от 36.',
    howToExplain: 'Скажите: если можно проверить — факт; если только «мне нравится» — мнение.',
    exampleDialogue: 'Parent: 1/3 от 36?\nChild: 12.\nParent: 1/4 от 36?\nChild: 9.\nParent: Проверить?\nChild: 15.',
    readingSupport: 'Слово «доказать» — по слогам.',
    russianSpeechGoal: 'Анита говорит: «Факт можно проверить, мнение — то, что человек думает.»',
    check: ['Анита разделила 36 на факты/мнения/проверить.', 'Анита нашла слабое утверждение B.'],
    spellingCheck: 'Проверить: факт, мнение, доказать, видеть, думать.',
    readingCheck: 'Попытка русского чтения 4 фраз.',
    practicalCheck: 'Указано слабое утверждение с объяснением.',
    discussionPrompts: ['Что такое факт?', 'Почему мнение можно уважать, но не считать доказанным?'],
    ifEasy: 'Придумать 3 факта и 3 мнения из повседневной жизни.',
    ifDifficult: 'Оставить задачи 3 и 5.',
    commonMistakes: ['«Мне нравится = факт.» Правильно: это мнение.', '«Мнение = ложь.» Правильно: мнение — просто позиция.'],
    drawingCriteria: 'Карточка «мой факт + моё мнение».',
    goal: 'Анита отличает факт от мнения, работает с дробями от 36 и считает 42 ÷ 6.',
    mathGoal: 'U.S. Grade 3: 1/3 и 1/4 от 36; 5 × 4 − 6; сумма трат из 72; 42 ÷ 6.',
    russianGoal: 'Прочитать 5 слов и 4 фразы; написать 5 слов.',
    readingWritingGoal: 'Карточка «мой факт + моё мнение» + логический ответ.',
    parentTheoryCard: {
      title: 'Факт vs мнение',
      purpose: 'Показать разницу и научить требовать доказательство.',
      keyMessage: 'Факт можно проверить. Мнение — просто то, что человек думает.',
      parentScript: ['«Если это факт, я могу это проверить.»', '«Если это мнение — уважаем, но не считаем доказанным.»', '«1/3 от 36 = 12; 1/4 от 36 = 9.»', '«42 ÷ 6 = 7 дней.»'],
      practiceSteps: ['Дайте примеры факта и мнения из повседневной жизни.', 'Проверьте задачу с нимами (72 − 42 = 30).', 'Обсудите, почему B — слабое утверждение.'],
      paperOnlyNotes: ['Все задания на бумаге.', 'Никаких настоящих переходов по сайтам.'],
      doNotSay: ['Не смешивай факт и мнение в одно.', 'Не давай готовое B без обсуждения.']
    },
    keyMessage: 'Точный вопрос, надёжный источник, факт с доказательством, проверка ИИ, опыт про плотность.',
    mathAnswerKey:
      'math-36-sentences: 36 ÷ 3 = 12; 36 ÷ 4 = 9; 36 − 12 − 9 = 15.\n' +
      'math-evidence-groups: 5 × 4 = 20; 20 − 6 = 14.\n' +
      'math-nims-72: 18 + 24 = 42; 72 − 42 = 30.\n' +
      'math-42-days: 42 ÷ 6 = 7.',
    spellingAnswerKey: 'факт\nмнение\nдоказать\nвидеть\nдумать',
    answerKey: [
      { taskId: 'reading-words', answer: '5 слов.' },
      { taskId: 'reading-sentences', answer: '4 фраз.' },
      { taskId: 'math-36-sentences', answer: '12; 9; 15.' },
      { taskId: 'math-evidence-groups', answer: '20; 14.' },
      { taskId: 'math-nims-72', answer: '42; 30.' },
      { taskId: 'math-42-days', answer: '7.' },
      { taskId: 'logic-weak-claim', answer: 'B — мнение без доказательства.' },
      { taskId: 'spelling-day3', answer: '5 слов.' },
      { taskId: 'creative-fact-opinion', answer: 'Карточка факт+мнение.' },
      { taskId: 'speech-day3', answer: 'Идея факт vs мнение по-русски.' }
    ],
    parentOnlyNotes: 'Не оценивайте реальные книги или людей; используйте только выдуманные примеры.',
    rewardGuidance: 'Базовая награда — 3 нима.',
    tokenReward: 'Нимы — это призовые токены курса, а не оплата.',
    safetyNotes: 'Работа только на бумаге. Никаких оценок реальных людей или книг.'
  },
  reward: { unit: 'nim', unitName: 'ним', base: 3, max: 5, label: 'Награда за миссию', display: '3 нима', bonuses: [
    { id: 'clear-fact-vs-opinion', label: 'Бонус за ясный факт vs мнение', amount: 1 }
  ] },
  completionRequirements: {
    requiredTaskIds: ['reading-words', 'reading-sentences', 'math-36-sentences', 'math-evidence-groups', 'math-nims-72', 'math-42-days', 'logic-weak-claim', 'spelling-day3', 'creative-fact-opinion', 'speech-day3'],
    allowNotebookCompletion: true
  },
  nextLessonId: 'anita-week-5-day-4'
};

export default day3;
